import { createUrl, getObject, getObjects, patchObject, postObject, putObject, REACT_APP_API_URL } from "../Common/js/api_common"

export const ENDPOINT_CHARAC_TYPES = "/api/charac_types"

export async function getCharacTypes(parameters = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_CHARAC_TYPES
  const defaultParameters = {}
  url = createUrl(url, parameters, defaultParameters)
  return await getObjects(url)
}

export async function getCharacType(id) {
  let url = REACT_APP_API_URL + ENDPOINT_CHARAC_TYPES + "/" + id
  return await getObject(url)
}

export async function putCharacType(id, putValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_CHARAC_TYPES + "/" + id
  return await putObject(url, putValues)
}

export async function patchCharacType(id, patchValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_CHARAC_TYPES + "/" + id
  return await patchObject(url, patchValues)
}

export async function postCharacType(postValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_CHARAC_TYPES
  return await postObject(url, postValues)
}
